import { ContactSection } from '../components/ContactForm'
import { faq } from '../lib/faq'
import { SiteHeader, SiteFooter } from '../components/SiteHeader'

const services = [
  {
    titre: 'Planification',
    accroche: 'On comprend votre entreprise avant de sortir la caméra.',
    desc: 'Une rencontre pour cerner votre message, votre public et ce que la vidéo doit accomplir. On repère vos lieux, on bâtit le déroulement du tournage et on vous envoie un plan clair. Vous savez exactement à quoi vous attendre.',
    inclus: ['Rencontre de démarrage et analyse de vos besoins', 'Scénario, liste de plans et horaire de tournage', 'Repérage des lieux et coordination avec votre équipe'],
  },
  {
    titre: 'Tournage',
    accroche: 'Une équipe qui sait travailler en usine comme sur un chantier.',
    desc: 'On se déplace partout au Québec avec un équipement 4K, l\'éclairage et le son. On capte vos installations, vos gens et votre savoir-faire sans nuire à vos opérations. On est habiles avec le drone pour montrer l\'ampleur de vos projets.',
    inclus: ['Caméras 4K, éclairage et prise de son professionnelle', 'Plans aériens par drone', 'Entrevues, plans d\'action et détails techniques'],
  },
  {
    titre: 'Montage',
    accroche: 'Le rythme, la couleur et le son qui font réagir.',
    desc: 'Montage narratif, étalonnage des couleurs, mixage sonore et animations de textes. On livre un format principal pour votre site ou vos présentations, plus des versions courtes pour les réseaux sociaux.',
    inclus: ['Montage, colorisation et sound design', 'Versions verticales pour Instagram, TikTok et YouTube Shorts', 'Sous-titres et intégration de votre image de marque'],
  },
  {
    titre: 'Espace client',
    accroche: 'Vous suivez tout, sans courriels perdus.',
    desc: 'Chaque client a accès à un portail sécurisé. Vous y visionnez les versions de vos vidéos, laissez vos commentaires directement sur la ligne du temps, approuvez, puis téléchargez vos fichiers finaux en haute résolution.',
    inclus: ['Révision en ligne avec commentaires horodatés', 'Suivi de l\'avancement du projet et des rencontres', 'Téléchargement des livrables, factures et contrats au même endroit'],
  },
]

export default function Landing() {

  return (
    <div className="min-h-screen bg-noir text-blanc">
      <SiteHeader home />

      {/* Hero */}
      <section className="relative px-6 md:px-12 pt-20 pb-28 text-center overflow-hidden">
        <div className="absolute inset-0 opacity-[0.04] pointer-events-none"
             style={{ backgroundImage: 'linear-gradient(#fff 1px,transparent 1px),linear-gradient(90deg,#fff 1px,transparent 1px)', backgroundSize: '60px 60px' }} />
        <div className="relative max-w-4xl mx-auto">
          <p className="text-orange uppercase tracking-[0.4em] text-xs mb-6">Production vidéo industrielle · Québec</p>
          <h1 className="font-display text-6xl md:text-8xl tracking-wide leading-[0.95]">
            On capte<br />ce qui compte
          </h1>
          <p className="text-acier text-lg md:text-xl mt-8 max-w-2xl mx-auto font-light">
            Tournage, montage, reels et drone 4K. On livre des vidéos qui font réagir,
            pensées pour l'industrie, la construction et les entreprises du Québec.
          </p>
          <div className="mt-10 flex flex-wrap gap-4 justify-center">
            <a href="#contact" className="bg-orange hover:bg-orange-hover transition-colors px-8 py-4 uppercase tracking-widest text-sm font-bold rounded-sm">
              Réponse en 24h
            </a>
            <a href="/portfolio" className="border border-white/15 hover:border-orange transition-colors px-8 py-4 uppercase tracking-widest text-sm">
              Voir le portfolio
            </a>
          </div>
        </div>
      </section>

      {/* Services */}
      <section id="services" className="px-6 md:px-12 py-20 border-t border-white/5">
        <div className="max-w-5xl mx-auto">
          <div className="w-12 h-0.5 bg-orange mb-6" />
          <div className="flex flex-wrap items-end justify-between gap-4 mb-14">
            <h2 className="font-display text-4xl md:text-5xl tracking-wide">Ce qu'on fait</h2>
            <p className="text-acier text-sm max-w-md">De la première rencontre à la livraison finale, un seul interlocuteur et un processus clair en quatre étapes.</p>
          </div>
          <div className="grid md:grid-cols-2 gap-px bg-white/5 border border-white/5">
            {services.map((s, i) => (
              <div key={s.titre} className="bg-noir p-8 md:p-10 relative group hover:bg-white/[0.02] transition-colors">
                <div className="flex items-baseline gap-4">
                  <span className="font-display text-5xl text-orange/70 group-hover:text-orange transition-colors leading-none">0{i + 1}</span>
                  <div>
                    <h3 className="font-display text-3xl tracking-wide">{s.titre}</h3>
                    <p className="text-blanc/90 text-sm mt-1">{s.accroche}</p>
                  </div>
                </div>
                <p className="text-acier text-sm leading-relaxed mt-5">{s.desc}</p>
                <ul className="mt-5 space-y-2">
                  {s.inclus.map(x => (
                    <li key={x} className="flex gap-3 text-sm text-blanc/80"><span className="text-orange mt-[2px]">▸</span><span>{x}</span></li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section id="faq" className="px-6 md:px-12 py-20 border-t border-white/5">
        <div className="max-w-4xl mx-auto">
          <div className="w-12 h-0.5 bg-orange mb-6" />
          <h2 className="font-display text-4xl md:text-5xl tracking-wide mb-12">Questions fréquentes</h2>
          <div className="divide-y divide-white/10 border-y border-white/10">
            {faq.map(f => (
              <details key={f.q} className="group py-5">
                <summary className="flex items-center justify-between cursor-pointer list-none gap-4">
                  <h3 className="font-display text-2xl tracking-wide">{f.q}</h3>
                  <span className="text-orange text-2xl leading-none transition-transform group-open:rotate-45">+</span>
                </summary>
                <p className="text-acier text-sm leading-relaxed mt-3 max-w-3xl">{f.a}</p>
              </details>
            ))}
          </div>
        </div>
      </section>

      <ContactSection page="accueil" />

      <SiteFooter />
    </div>
  )
}
